<template>
  <loading-overlay :active="isLoading" :is-full-page="true" :width="128" :height="128" loader="spinner" color="rgb(var(--color-active-hsl-128))" background-color="rgb(var(--color-b-back))" />
  <SrcBackgroundScroll @scrolled="isShrunk = $event">
    <HeadlineSubScroll 
        :title="$t('settings.country')" 
        target="/Settings" 
        :hassubline="!isShrunk"
        :hasmenu="false"
        :isShrunk="isShrunk"
        >
          <template #icon>
            <IconEditSquare             
              class="transition-all duration-300"
              :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"/>
          </template>
          <template #subline>
            {{ $t('settings.settingsfor',{wallbox:this.decodeHtml(this.$store.state.WbName)} ) }}
          </template>
    </HeadlineSubScroll>

    <ConfirmLeaveModal
      v-model:show="showLeaveDialog"
      :pendingNavigation="this.leaveDialog"
    />

    <SettingsHeader :admin="this.$store.state.Role=='admin'">
      {{ this.decodeHtml(this.$store.state.WbName) }}
    </SettingsHeader>

    <SettingsBody>
      <template v-slot:formgrid>

          <div class="mt-2 mb-2 sm:col-span-2">
            <ToggleWithLabel 
              v-model="tor_enabled"
              :label="$t('setcountry.austria')"
              :ontext="$t('common.on')"
              :offtext="$t('common.off')"
              @update:modelValue ="onChange"
            />
          </div>
      
          
          <div class="form-group mb-6">
            <InputLabelError 
              v-model="tor_reconnectsec"
              :disabled="!tor_enabled"
              :label="$t('setcountry.reconnectsec')"
              :placeholder="$t('setcountry.reconnectsec')"
              validationType="number"
              :validator_off="!tor_enabled"
              @valid="(status) => valid_reconnectsec = status"
              @update:modelValue ="onChange"
            />
          </div>
          <div class="form-group mb-6">
            <InputLabelError 
              v-model="tor_uvpercent"
              :disabled="!tor_enabled"
              :label="$t('setcountry.uvpercent')"
              :placeholder="$t('setcountry.uvpercent')"
              validationType="number"
              :validator_off="!tor_enabled"
              @valid="(status) => valid_uvpercent = status"
              @update:modelValue ="onChange"
            />
            <InputLabelError 
              v-model="tor_uvsec"
              :disabled="!tor_enabled"
              :label="$t('setcountry.uvsec')"
              :placeholder="$t('setcountry.uvsec')"
              validationType="number"
              :validator_off="!tor_enabled"
              @valid="(status) => valid_uvsec = status"
              @update:modelValue ="onChange"
          />
          </div>

        </template>
        <template v-slot:formbottom>
          <div class="w-full mt-6">
            <ActionButton @click="saveCountry()" :disabled="!isValid || !this.isDirty">
              {{ $t('common.save') }}
            </ActionButton>
          </div>

        </template>
    </SettingsBody>
  </SrcBackgroundScroll>
</template>

<script>
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconEditSquare from './icons/IconEditSquare.vue'
import SettingsHeader from './elements/SettingsHeader.vue'
import SettingsBody from './elements/SettingsBody.vue'
import ActionButton from './elements/ActionButton.vue'
import InputLabelError from './elements/InputLabelError.vue'
import ToggleWithLabel from './elements/ToggleWithLabel.vue'
import ConfirmLeaveModal from './elements/ConfirmLeaveModal.vue'
import { useI18n } from 'vue-i18n'

export default {
  setup () {
      const { t,d,n } = useI18n()
      return { t,d,n }
    },  
  components: {
      SrcBackgroundScroll, HeadlineSubScroll, IconEditSquare,
      SettingsHeader, SettingsBody, ActionButton,
      InputLabelError, ToggleWithLabel, ConfirmLeaveModal
    }, 
  data() {
    return {
          isLoading: false,
          saveto: this.$store.state.WbId,
          tor_enabled: false,
          tor_reconnectsec: 0,
          valid_reconnectsec: false,
          tor_uvpercent: 0,
          valid_uvpercent: false,
          tor_uvsec: 0,
          valid_uvsec: false,
          isShrunk: false,

          isDirty:false,
          showLeaveDialog:false
    }
  },
  beforeRouteLeave(to, from, next) {

    if (this.isDirty || this.editmode) {
      this.showLeaveDialog = true;
      this.pendingNavigation = next;    
    } else {
      next();
    }
  },
  computed: {
    isValid() {
      return this.valid_reconnectsec && this.valid_uvpercent && this.valid_uvsec;
    }
  },
  methods: {
    onChange() {this.isDirty = true;},
    leaveDialog(){this.pendingNavigation();},
    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
      },
    saveCountry() {
      this.isDirty=false;

      let lv_enabled = this.tor_enabled ? '1' : '0';

      let lv_reconnectsec = Math.min(300, Math.max(0, this.tor_reconnectsec)) || 0;
      lv_reconnectsec = String(lv_reconnectsec);

      let lv_uvpercent = Math.min(100, Math.max(0, this.tor_uvpercent)) || 0;
      lv_uvpercent = String(lv_uvpercent);

      let lv_uvsec = Math.min(100, Math.max(0, this.tor_uvsec)) || 0;
      lv_uvsec = String(lv_uvsec);

      this.axios
      .get('wallbox/settings.php?action=sync_tor&client='+this.saveto+'&tor_enabled='+lv_enabled+'&tor_reconnectsec='+lv_reconnectsec+'&tor_uvpercent='+lv_uvpercent+'&tor_uvsec='+lv_uvsec+'&user='+this.$store.state.token)
      .then((response) => {        
                  if(response.data.status=='ok'){
                    console.log('country settings saved');
                    this.loadCountry();
                  }else{
                    console.log('country settings failed');
                    this.loadCountry();                 
                  }
                })
                .catch((errors) => {
                    console.log(errors); // Errors
                    this.loadCountry();
                });
    },
    loadCountry() {
      this.isLoading = true;
      let client_SettingsUrl = 'wallbox/info.php?action=get_settings&user='+this.$store.state.token+'&client='+this.$store.state.WbId;

      const requestclient_Settings = this.axios.get(client_SettingsUrl);

      this.axios
          .all([requestclient_Settings])
          .then(
              this.axios.spread((...responses) => {
                  const responseclient_Settings = responses[0];

                  if(responseclient_Settings.data.status=='token'){
                        this.$router.push({path: '/'});             
                    }else if(responseclient_Settings.data.status=='ok'){
                      this.tor_enabled = responseclient_Settings.data.tbl_settings.torEnabled === 1;
                      this.tor_reconnectsec = responseclient_Settings.data.tbl_settings.torReconnectSec || 0;
                      this.tor_uvpercent = responseclient_Settings.data.tbl_settings.torUVPerCent || 0;
                      this.tor_uvsec = responseclient_Settings.data.tbl_settings.torUVSec || 0;
                  }else{
                    console.log('Error get Settings Table');
                  }

              this.isLoading = false;
              })
          )
          .catch((errors) => {
              this.isLoading = false;
              console.error(errors);
          });
    }
  },
  created() {  
    this.loadCountry();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="@vueform/toggle/themes/default.css"></style>
<style scoped>
</style>
